"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VasClient = void 0;
const UnknownSimStatusError_1 = require("../shared/errors/UnknownSimStatusError");
class VasClient {
    constructor(authServiceV2, loggingFacade, stage) {
        this.authServiceV2 = authServiceV2;
        this.loggingFacade = loggingFacade;
        this.stage = stage;
        this.resourceHostId = `myvw-vas-${this.stage}`;
    }
    async getEnrollmentUrl(vin, successUrl, requestedSteps, cancelUrl) {
        return this.getUrlFor(vin, successUrl, requestedSteps || 'VW_PE_VE_1', cancelUrl);
    }
    async getProfileEnrichmentUrl(vin, successUrl, requestedSteps) {
        return this.getUrlFor(vin, successUrl, requestedSteps || 'VW_PE_1');
    }
    async getUrlFor(vin, successUrl, requestedSteps, cancelUrl) {
        const query = `auth/users/__userId__/session`;
        const postDataObj = {
            success: successUrl,
            vin,
            requestedSteps,
            cancelUrl: cancelUrl || undefined,
        };
        const postData = JSON.stringify(postDataObj);
        try {
            const response = await this.authServiceV2.post(this.resourceHostId, query, postData, { 'Content-Type': 'application/json' });
            if (response.headers.has('Location')) {
                return response.headers.get('Location');
            }
            // TODO: Clean this code smell
            throw new Error('There is not Location in the VAS headers response');
        }
        catch (error) {
            throw this.handleError(error);
        }
    }
    async getUserStatus(vin) {
        const query = `auth/v2/users/__userId__/status?vin=${vin}&requestedSteps=VW_Dynamic_1`;
        try {
            const response = await this.authServiceV2.get(this.resourceHostId, query);
            return await response.json();
        }
        catch (error) {
            throw this.handleError(error);
        }
    }
    async getUserIdentStatus(vin) {
        const query = `auth/v2/users/__userId__/status/ident?vin=${vin}`;
        try {
            const response = await this.authServiceV2.get(this.resourceHostId, query);
            return await response.json();
        }
        catch (error) {
            throw this.handleError(error);
        }
    }
    handleError(error) {
        var _a;
        const errorCode = (_a = error.errorDetail) === null || _a === void 0 ? void 0 : _a.errorCode;
        if (error.status === 400 && errorCode === '1009') {
            error = new UnknownSimStatusError_1.UnknownSimStatusError();
        }
        const errorMessage = errorCode
            ? `VAS call failed with error code ${errorCode}`
            : 'VAS call failed. No error code provided.';
        this.loggingFacade.error(errorMessage, error);
        return error;
    }
}
exports.VasClient = VasClient;
//# sourceMappingURL=VasClient.js.map